// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { DeleteSession } from "@insite/client-framework/Store/Context/Handlers/SignOut";

export const chain = [DeleteSession];

const signOutWithoutHomeRedirect = createHandlerChainRunnerOptionalParameter(chain, {}, "SignOutWithoutHomeRedirect");
export default signOutWithoutHomeRedirect;
